<template>
<div v-if="loaded">
<!-- {{cleanData[0].data.length}} -->

<div v-if="cleanData[0].data.length!=0">
<BarChart :labels="labels" :dataset="cleanData" />
</div>
</div>

</template>


<script>
import BarChart from './BarChart.vue'

export default {
     components: {BarChart
  },
  props:{
    //   Headline: String,
      labels: {
      type: Array,
      default: null},
      dataset: {
      type: Array,
      default: null},
      nameLabel: {
      type: String,
      default: null},
  },
  data() {
    return {
      loaded:false,
      cleanData:[{
            label: 'Alla',
            data: [],
                     }],
     
    };
  },
  // mounted() {

    created: async function() {
let values=[0,0,0]
this.dataset.forEach(data => {
  if (data=="1") {
    values[0]= values[0]+1
  }
  else if (data=="0") {
    values[1]= values[1]+1
  }
  else{
    values[2]= values[2]+1
  }
});
this.cleanData=[{
            label: this.nameLabel!=null?this.nameLabel:'Alla',
            data:[values[0],values[1],values[2]],            
            backgroundColor: ["#A5D6A7", "#EF5350", "#90CAF9", "blue", "red", "blue"], 

          } ]
//  (this.cleanData)
this.loaded=true;
  }
};
</script>
